import React, {useCallback, useEffect} from 'react';
import {BarStatistics} from "./StatisticsComponents/BarStatistics";
import '../style/componentstyles.css'
import {Alert, Card, Col, Container, Row} from "react-bootstrap";

import '../style/componentstyles.css'

import {LineStatistics} from "./StatisticsComponents/LineStatistics";
import {useAuth} from "../contexts/AuthContext";
import {getUserCompany} from "../services/UserService";


export default function Dashboard() {
    const {currentUser} = useAuth();
    const [company, setCompany] = React.useState();
    const [error, setError] = React.useState(false);
    const [errorType, setErrorType] = React.useState("");
    const [errorText, setErrorText] = React.useState("");

    let timer;
    const fetchUserCompany = useCallback(async () => {
        try {
            const uid = await currentUser.uid;
            const userComp = await getUserCompany(uid);

            setCompany(userComp);
        } catch {

        }
    })

    useEffect(() => {
        fetchUserCompany().then(() => {
            setError(true);
            setErrorType("success")
            setErrorText("Inladdning av information lyckad.")
        }).catch(() => {
            setError(true);
            setErrorType("success")
            setErrorText("Inladdning av information lyckad.")
        }).finally(() => {
            timer = setTimeout(() => {
                setError(false)
            }, 5000);
        })

        clearTimeout(timer);

    }, [])

    return (

        <div className="container">

            <div className="row">
                <div>
                    <h2 style={{paddingLeft: '10%'}}>Översikt för: <b>{company}</b></h2>
                </div>

            </div>



                <div className={"row"}>

                    <div>
                        <Card>
                            <BarStatistics company={company}/>
                        </Card>
                    </div>
                    <hr/>
                    <div>
                        <Card>
                            <LineStatistics company={company}/>
                        </Card>
                    </div>
                </div>


        </div>
    )
}
